import axios from 'axios';

//const BACKEND_URL = `https://vtzpuzzleplex.uvcanngaming.com/`;
const BACKEND_URL = `/`;

const headers = {
  'Content-Type': 'application/json',
  'x-auth': 'M@#weh@##dhASD2627@#2024',
};

export const getPacksApi = async (userId) => {
  try {
    if (userId != null) {
      const response = await axios.get(
        `${BACKEND_URL}vtzppApi/auth/getPacks/${userId}`
      );
      return response.data;
    } else {
      const response = await axios.get(`${BACKEND_URL}vtzppApi/auth/getPacks`);
      return response.data;
    }
  } catch (e) {
    throw e.response.data;
  }
};

export const subApi = async (data) => {
  try {
    const response = await axios.post(`${BACKEND_URL}vtzppApi/auth/sub`, data);
    return response.data;
  } catch (e) {
    throw e.response.data;
  }
};

export const getSubStatusApi = async (data) => {
  try {
    const response = await axios.post(
      `${BACKEND_URL}vtzppApi/auth/getSubStatus`,
      data
    );
    return response.data;
  } catch (e) {
    throw e.response.data;
  }
};
export const unsubApi = async (token) => {
  try {
    headers.Authorization = 'Bearer ' + token;
    const response = await axios.post(`${BACKEND_URL}vtzppApi/user/unsub`, '', {
      headers: headers,
    });
    return response.data;
  } catch (e) {
    throw e.response.data;
  }
};
export async function registerApi(data) {
  const response = await axios.post(`${BACKEND_URL}api/register`, data);
  return response;
}

export async function loginApi(data) {
  const response = await axios.post(`${BACKEND_URL}api/login`, data);
  return response;
}

export async function levelsApi(token) {
  const response = await axios.post(
    `${BACKEND_URL}api/game/levels`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
}
export async function userlevelsApi(userId) {
  const response = await axios.get(
    `${BACKEND_URL}api/game/userlevels/${userId}`
  );
  return response;
}
export async function levelnoApi({ token, level_no, lang }) {
  const response = await axios.post(
    `${BACKEND_URL}api/game/level/${level_no}`,
    { lang },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
}

// export async function levelsdatainsertApi(data) {
//   const response = await axios.post(`${BACKEND_URL}game/leveladd`, data);
//   return response;
// }

export async function userdetailApi(token) {
  const response = await axios.post(
    `${BACKEND_URL}api/game/userdetail`,
    {}, // request body (empty if not needed)
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response;
}

export async function userprofileSave({ token, formData }) {
  console.log(token, 'token---------');
  return axios.put(`${BACKEND_URL}api/users/upload-profile`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

// export async function submitRiddleApi(data) {
//   const response = await axios.post(`${BACKEND_URL}game/submit-riddle`, data);
//   console.log(response, "response-----------");
//   return response;
// }

export const spinWheelApi = async (token) => {
  const response = await axios.post(
    `${BACKEND_URL}api/game/wheelspindisable`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
};

export const spinWheelRewardApi = async ({ token, reward_points }) => {
  const response = await axios.post(
    `${BACKEND_URL}api/game/spin-wheel-reward`,
    { reward_points },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const insertUserHistoryApi = async (token, data) => {
  const response = await axios.post(
    `${BACKEND_URL}api/game/user-history-insert`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const userTotalPointsApi = (token) => {
  const response = axios.get(`${BACKEND_URL}api/game/user-total-points`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const userHistoryApi = (token) => {
  console.log(token, 'jjjjjjjjjjtoken');
  const response = axios.get(`${BACKEND_URL}api/game/user-history-get`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response;
};

export const updateUserNameApi = ({ token, name }) => {
  return axios.put(
    `${BACKEND_URL}api/game/update-name`,
    { name },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const setuserlevellimtApi = (token) => {
  const response = axios.post(
    `${BACKEND_URL}api/game/play-level`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  console.log(response, '----------response');

  return response;
};

export const userspinApi = (token) => {
  const response = axios.get(`${BACKEND_URL}api/game/get-spin-reward`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response;
};

export const insertGoldenRewardApi = ({ token, reward }) => {
  const response = axios.post(
    `${BACKEND_URL}api/game/gold-reward-insert`,
    { reward },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  console.log(response, '----------response');
  return response;
};

export const GoldenRewardApi = (token) => {
  const response = axios.get(`${BACKEND_URL}api/game/get-golden-reward`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  console.log(response, '----------response');
  return response;
};

export const insertDiamondRewardApi = ({ token, payload }) => {
  const response = axios.post(
    `${BACKEND_URL}api/game/diamond-reward-insert`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  console.log(response, '----------response');
  return response;
};

export const diamondRewardApi = (token) => {
  const response = axios.get(`${BACKEND_URL}api/game/diamond-reward-get`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  console.log(response, '----------response');
  return response;
};
